<div class="content-with-filled-button">
  <h1 class="title">{{ copyService.copies.plazo_monto_title }}</h1>
  <p class="sub-title">{{ copyService.copies.plazo_monto_sub_title }}</p>
  <form id="formMeses" class="form row" [formGroup]="formGroup">
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field
        label="{{ copyService.copies.plazo_monto_label2 }}"
        [description]="description"
        [msgErr]="error_monto"
      >
        <input
          vclInput
          placeholder="$0"
          id="inputValueMonto"
          [option]="option"
          formControlName="monto"
          autocomplete="off"
          (focus)="updateValuemonto($event)"
          (input)="reactiveInputChangeMonto(); updateValuemonto($event)"
          (keyup)="updateValuemonto($event)"
        />
        <!-- onkeypress="return !(event.charCode == 46)" -->
      </vcl-form-field>
    </div>
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field
        label="{{ copyService.copies.plazo_monto_label }}"
        [description]="description_plazo"
        [msgErr]="error_plazo"
      >
        <input
          vclInput
          placeholder="0"
          id="inputValueMeses"
          type="number"
          [min]="6"
          (focus)="reactiveInputChangePlazo()"
          (input)="reactiveInputChangePlazo()"
          formControlName="plazo"
          autocomplete="off"
        />
      </vcl-form-field>
    </div>
  </form>
  <div class="magin_top_20">
    <div class="tasa-interes" *ngIf="showRate">
      <strong class="bottom-text" id="textFooter"
        >{{ copyService.copies.max_period_request_rate_title }} </strong
      ><br />
      <span class="bottom-text" id="textFooter">
        {{
          copyService.getParametrizedCopy('max_period_request_copy_rate2', [
            helperService.getRateBySegment(
              taxRates,
              SEGMENTS_CONST.PB,
              'NMV',
              RISK_LEVELS.NORISK
            ),
            helperService.getRateBySegment(
              taxRates,
              SEGMENTS_CONST.PB,
              'EA',
              RISK_LEVELS.NORISK,
              false,
              true
            )
          ])
        }}</span
      >
    </div>
    <div class="remmind magin_top_10" *ngIf="showRate">
      <p class="bottom-text" id="textFooter">
        {{ copyService.copies.max_period_request_copy_rate }}
      </p>
    </div>
  </div>
  <app-controls
    id="docIntroBtns"
    (only_previous)="previous()"
    [hasPrevious]="true"
    [nextLabel]="copyService.copies.plazo_monto_next_button"
    (next)="next()"
    [nextDisabled]="!validButton"
  ></app-controls>
</div>
